import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { ProductForm } from 'Services/ProductManagement/Features/Product/Components/ProductForm'
import { useSingleProduct } from 'Services/ProductManagement/Features/Product/Hooks'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function ProductCreatePage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/products`
  const previousLocation = usePreviousLocation(baseUrl)
  const { singleLoading, submitLoading } = useSingleProduct(undefined)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Products`,
      link: baseUrl
    },
    {
      title: t`Create new product`
    }
  ]

  const isLoading = singleLoading === 'pending'

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new product`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <ProductForm successBaseUrl={previousLocation} submitLoading={submitLoading} />
      </WithLoader>
    </Box>
  )
}
